function checkWebp() {
  var img = new Image();
  img.onload = function () {
    var flag = img.width > 0 && img.height > 0;
    recordWebpSupport(flag);
  };
  img.onerror = function () {
    recordWebpSupport(false);
  };
  img.src = 'data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA';
}
function checkAvif() {
  if (!window.createImageBitmap) {
    recordAvifSupport(false);
    return;
  }
  fetch('data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUEAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABYAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgSAAAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB5tZGF0EgAKBzgADlAgIGkyCR/wAABAAACvcA==').then(function (r) {
    return r.blob();
  }).then(function (blob) {
    return createImageBitmap(blob);
  }).then(function () {
    return recordAvifSupport(true);
  }, function () {
    return recordAvifSupport(false);
  });
}
function recordWebpSupport(flag) {
  window.is_browser_support_webp = flag;
  try {
    window.localStorage && window.localStorage.setItem('isWebpSupport', flag ? '1' : '0');
  } catch (e) {
    console.log(e);
  }
}
function recordAvifSupport(flag) {
  window.is_browser_support_avif = flag;
  try {
    window.localStorage && window.localStorage.setItem('isAvifSupport', flag ? '1' : '0');
  } catch (e) {
    console.log(e);
  }
}
function isWeex() {
  return typeof callNative === 'function' || typeof WXEnvironment === 'object' && WXEnvironment.platform !== 'Web';
}
function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
}
function iOSVersion() {
  var v = navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
  if (v && v.length) {
    return parseInt(v[1], 10);
  }
  return '';
}
function detect() {
  if (typeof window === 'undefined') return;
  if (isWeex()) {
    window.is_browser_support_webp = !(isIOS() && iOSVersion() <= 13);
    return;
  }
  if (window.localStorage && window.localStorage.getItem('isWebpSupport')) {
    window.is_browser_support_webp = window.localStorage.getItem('isWebpSupport') === '1';
  } else {
    checkWebp();
  }
  if (window.localStorage && window.localStorage.getItem('isAvifSupport')) {
    window.is_browser_support_avif = window.localStorage.getItem('isAvifSupport') === '1';
  } else {
    checkAvif();
  }
}
detect();
export var isSupportWebp = function () {
  if (typeof window === 'undefined' || window.is_browser_support_webp === undefined) return false;
  return window.is_browser_support_webp;
};
export var isSupportAvif = function () {
  if (typeof window === 'undefined' || window.is_browser_support_avif === undefined) return false;
  return window.is_browser_support_avif;
};